/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export const transformer = {
  /**
   * @param {object} product
   *
   * @returns {object}
   */
  transformProductToSearchHit(product) {
    const {id: productId, name: productName, type: productType} = product;
    const hitTypes = {
      bundle: 'bundle',
      item: 'product',
      master: 'master',
      option: 'option',
      set: 'set',
      variant: 'variant',
      variationGroup: 'variation_group',
    };

    return {
      ...product,
      productId,
      productName,
      productType,
      hitType: hitTypes[Object.keys(hitTypes).find((type) => product.type[type])],
      image: product.imageGroups[0]?.images[0],
    };
  },
};
